import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMAprilfoolPopupView extends React.Component {

  constructor(props) {
    super(props);

    this.dismiss = this.dismiss.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
    }
  }

  dismiss(e) {
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.aprilfoolPopupViewDidClose === 'function'){
        this.props.delegate.aprilfoolPopupViewDidClose();
      }
    }
  }

  render() {
    return(
      <div>
        <div className="page__popup aprilfool2017__popup md-modal md-effect-101" ref="modal">
          <div className="md-content">

            <div className="page__popup-col1">
              <div className="popup-headline">
                <img src={SMRailsBridge.assetPath.aprilfool2017PopupTitle} className="aprilfool2017__popup-title-img" alt="" />
                <h1 className="aprilfool2017__popup-title">SORRY...</h1>
                <h2 className="popup-headline__title">宇宙条約により宇宙空間の貸し借りはできません。</h2>
                <p className="popup-headline__text">申し訳ありませんが、現在は地球上のスペースのみをお楽しみください。</p>
                <p className="aprilfool2017__popup-close"><a href="https://ja.wikipedia.org/wiki/%E5%AE%87%E5%AE%99%E6%9D%A1%E7%B4%84" target="_blank"><i className="fa fa-info-circle mr5"></i>宇宙条約とは （Wikipedia）</a></p>
            </div>
              <a href="https://spacemarket.com" className="button-blue aprilfool2017__popup-button">
                やっぱり地球のスペースを借りる
              </a>
              <h4 className="aprilfool2017__share-title">宇宙に行きたくなったらシェア！</h4>
              <ul className="row aprilfool2017__social">
                <li className="col-xs-6 col-md-3 sm-mb10">
                  <a href={this.props.twitterUrl} target="_blank" className=" aprilfool2017__social-twitter"><i className="fa fa-twitter"></i></a>
                </li>
                <li className="col-xs-6 col-md-3 sm-mb10">
                  <a href={this.props.facebookUrl} target="_blank" className="aprilfool2017__social-facebook"><i className="fa fa-facebook-square"></i></a>
                </li>
                <li className="col-xs-6 col-md-3">
                  <a href={this.props.pocketUrl} target="_blank" className="aprilfool2017__social-pocket"><i className="fa fa-get-pocket"></i></a>
                </li>
                <li className="col-xs-6 col-md-3">
                  <div className="aprilfool2017__social-like">
                    <div className="fb-like" data-href={this.props.url} data-layout="button_count" data-action="like" data-show-faces="true" data-share="false" style={{display: this.props.isOpen ? '' : 'none' }}></div>              </div>
                </li>
              </ul>
              <p className="aprilfool2017__popup-close md-close"><a href="#" onClick={this.dismiss}><i className="fa fa-times mr5"></i>閉じる</a></p>
            </div>

          </div>

        </div>
        <div className="md-overlay"></div>
      </div>
    );
  };
}

export default SMAprilfoolPopupView;



// WEBPACK FOOTER //
// ./app/javascript/components/others/SMAprilfoolPopupView.jsx